'use client';

import { useEffect, useState } from 'react';

/**
 * Client-only clock: null on the server and during hydration, so minute-sensitive
 * UI (clocks, "now" rules, today highlights) never lands in the server HTML where
 * the text can drift from the client render and fail hydration (React #418).
 * A null interval pauses the clock; the last value holds until it resumes.
 */
export function useClientNow(intervalMs: number | null): Date | null {
  const [now, setNow] = useState<Date | null>(null);
  useEffect(() => {
    if (intervalMs === null) return;
    setNow(new Date());
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
